import { useMutation, UseMutationOptions } from 'react-query';
import { mutateSuspendProposition } from './suspendProposition';
import { TSuspendPropositionBody } from './suspendProposition.types';

export const useMutationSuspendProposition = (
  options?: UseMutationOptions<unknown, unknown, TSuspendPropositionBody>
) => useMutation((data) => mutateSuspendProposition(data), options);
